var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CardApiClient } from './cardApiClient';
import { serializeParams } from '../utils/queryStringUtils';
import { filtersToParams } from '../utils/filtersUtils';
function buildReportsParams(_a) {
    var filters = _a.filters, page = _a.page, _b = _a.perPage, perPage = _b === void 0 ? 10 : _b;
    // eslint-disable-next-line @typescript-eslint/camelcase
    return serializeParams(__assign(__assign({}, filtersToParams(filters)), { page: page, per_page: perPage }));
}
export function getReports(params) {
    return CardApiClient.get("/v2/reports?" + buildReportsParams(params)).then(function (response) { return response.data; });
}
export function getDownloadLink(params) {
    return CardApiClient.get("/v2/reports/" + params.reportId + "/download_link").then(function (response) { return response.data.link; });
}
